import type { ErrorEvent, EventHint } from '@sentry/vue';
import { HttpStatusCode } from 'axios';
import { MISSING_I18N_TAG } from './missing-translation-tag.ts';

/**
 * Drops Sentry events whose original exception is an Axios error with HTTP 400.
 * Used as part of `beforeSend` so client validation errors do not flood the project.
 */
export function shouldDropSentryEventForAxiosBadRequest(
  hint: EventHint | undefined,
): boolean {
  const errorCode = (
    hint?.originalException as { response?: { status: number } } | undefined
  )?.response?.status;
  return errorCode === HttpStatusCode.BadRequest;
}

/**
 * Strips the synthetic stacktrace that `attachStacktrace` adds to missing-translation
 * messages. Without this, Sentry titles every one of them after the top frame
 * (`<anonymous>` inside the reporter) instead of the message naming the absent key.
 */
export function stripStacktraceFromMissingTranslationEvent(
  event: ErrorEvent,
): ErrorEvent {
  if (event.tags?.[MISSING_I18N_TAG] !== 'true') {
    return event;
  }

  const { exception: _exception, threads: _threads, ...rest } = event;
  return rest;
}
